// extracted by mini-css-extract-plugin
module.exports = {"divider":"Headline_divider__qai1T","headline":"Headline_headline__QEnPW","subline":"Headline_subline__bA3py","center":"Headline_center__sIq7Y","right":"Headline_right__VmcE5"};